var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17217 18.4908L17.991 6.67206C18.242 6.421 18.347 6.11899 18.092 5.86394C17.8369 5.60889 17.5349 5.71389 17.2839 5.96496L5.46507 17.7837C5.214 18.0348 5.109 18.3368 5.36405 18.5919C5.6191 18.8469 5.92111 18.7419 6.17217 18.4908Z",
    fill: "#011E29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9908 17.7837L6.17203 5.96494C5.92097 5.71388 5.61896 5.60888 5.36391 5.86393C5.10886 6.11898 5.21386 6.42099 5.46493 6.67205L17.2837 18.4908C17.5348 18.7419 17.8368 18.8469 18.0918 18.5919C18.3469 18.3368 18.2419 18.0348 17.9908 17.7837Z",
    fill: "#011E29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenu);
export default __webpack_public_path__ + "static/media/close-menu.b5ea5875fa75924d4f144c99dc10ed37.svg";
export { ForwardRef as ReactComponent };